module.exports = __webpack_public_path__ + "Upsell_Insights_Dark.1fbccb0fc7e9a6d6499ef5a1a4388777.hashedasset.svg";